import styled from 'styled-components';

export const Container = styled.div`
  overflow: hidden;
  position: relative;
  border-radius: ${({ theme }) => theme.borderRadius.default};
`;
